// Sohbet listesini çekerken çöz (9.34 · D-617).
//
// D-612'de kararlaştırılan şey: önizleme YEREL kopyadan gelir, sunucudan değil —
// sunucu zaten üretemez, elindeki tek şey zarftır. Signal ve Telegram'ın gizli
// sohbetleri de aynısını yapar.
//
// Çözme, `messages.ts`'te olduğu gibi çağrı yerine değil ÇEKME İŞİNE bağlı:
// gelen kutusu `api.getConversations` yerine bunu kullanır, böylece yarın başka
// bir ekran listeyi çekerse şifreli satırı ham gösterme ihtimali doğmaz.
//
// Okunmamış sayacı bilerek DIŞARIDA: oradan yalnız sayılar okunuyor, önizleme
// değil. Onu da çözdürmek hem boşuna iş hem de gereksiz ratchet yıpratmasıdır.
import { api, Conversation } from '../services/api';
import { resolveIncoming } from './plaintextCache';
import { myDeviceId } from './session';
import { decodeMessagePayload } from '../linkPreview/payload';

/**
 * Şifreli satırların önizlemesini yerel kopyadan doldur.
 *
 * Çözülen satır `text` türüne dönüşür, yani çizim katmanı değişmeden düz metni
 * yazar. Çözülemeyen satır `encrypted` KALIR ve listede "Şifreli mesaj" görünür —
 * D-612'nin dediği gibi bu istisna olmalı, kural değil.
 *
 * `last_message_id` yoksa (çağrı satırları) hiç dokunulmaz.
 */
export async function decryptConversations(list: Conversation[]): Promise<Conversation[]> {
  return Promise.all(list.map(async (c) => {
    if (c.last_type !== 'encrypted' || c.last_message_id == null) return c;
    const resolved = await resolveIncoming(c.other_id, c.last_message_id, c.last_content, c.last_edit_revision ?? 0);
    // 9.32 / D-653 — önizlemeli mesajda listede yalnız metin görünür.
    return resolved.ok ? { ...c, last_content: decodeMessagePayload(resolved.text).text, last_type: 'text' } : c;
  }));
}

/**
 * `api.getConversations` + önizleme çözme. Gelen kutusu bunu kullanır.
 *
 * Cihaz numarası da gidiyor (9.34 · D-628): sunucudaki eski alan yalnız TEK
 * cihazın zarfını taşıyor, o yüzden ikinci cihaz kendi zarfını istemezse
 * listede açamayacağı bir şey alır ve satır "Şifreli mesaj" kalır.
 */
export async function getConversations(
  token: string,
  archived: boolean = false,
): Promise<Conversation[]> {
  return decryptConversations(await api.getConversations(token, archived, await myDeviceId()));
}
